import { useTranslation } from "react-i18next";

import { activityLevel } from "@/lib/format";
import { cn } from "@/lib/utils";

const fill = {
  low: "bg-danger-solid",
  medium: "bg-warning-solid",
  high: "bg-success-solid",
} as const;

/** Horizontal bar with the activity percentage, colored by level. */
export function ActivityBar({ percent, className }: { percent: number; className?: string }) {
  const { t } = useTranslation();
  const value = Math.min(100, Math.max(0, Math.round(percent)));
  const level = activityLevel(value);

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div
        role="meter"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={t("activity.label")}
        className="h-1.5 w-full min-w-16 overflow-hidden rounded-full bg-surface-muted"
      >
        <div className={cn("h-full rounded-full", fill[level])} style={{ width: `${value}%` }} />
      </div>
      <span className="w-9 text-right text-xs text-muted tabular-nums">{value}%</span>
    </div>
  );
}
